<template>
  <el-dialog v-if="dialogTableVisible" class="dialog-box" :visible.sync="dialogTableVisible" width="80%" style="min-width: 800px;" top="13vh" :append-to-body="true" :close-on-click-modal="false">
    <div slot="title">
      <span style="font-size: 18px;color: #333;font-weight: 600;margin-right: 8px;">{{ type == 'edit' ? '编辑自定义列' : '新建自定义列' }}</span>
      <span v-if="type != 'edit'" style="font-size: 14px;color: #999">自定义列模板最多支持创建5个</span>
    </div>

    <el-form ref="nameFormRef" :model="columnForm">
      <el-form-item label="名称" label-width="56px" prop="name" :rules="[{required: true, message: '自定义列名称为必填项', max: 10, trigger: ['blur', 'change'] }]">
        <el-input v-model="columnForm.name" maxlength="10" style="width: 280px" size="medium" />
      </el-form-item>
    </el-form>

    <el-row class="center-box" :gutter="24">
      <!--  :sm="17" :md="17" :lg="17" -->
      <el-col :span="17">
        <el-card class="left-card" shadow="never">
          <el-row class="center-box" :gutter="24">
            <!-- :sm="5" :md="5" :lg="5"  -->
            <el-col :span="5" style="padding-left: 20px">
              <div class="lef-list">
                <el-scrollbar wrap-class="scrollbar-wrapper">
                  <div v-for="(item,index) in resultData" :key="item.property+'_left'+index" class="item" :class="{active:index==current}" @click="tabclick(index)">
                    {{ item.label }}
                  </div>
                </el-scrollbar>
              </div>
            </el-col>
            <!-- :sm="19" :md="19" :lg="19" -->
            <el-col :span="19" style="padding: 0">
              <div v-if="resultData.length > 0" class="right-list">
                <el-input v-model="search" size="medium" placeholder="请输入搜索指标名称" clearable style="border-radius: 6px;margin-bottom: 10px;">
                  <svg-icon slot="prefix" icon-class="search" style="font-size: 20px" />
                </el-input>
                <el-scrollbar wrap-class="scrollbar-wrapper">
                  <div v-for="(item,index) in resultData" v-if="item.children && item.children.length > 0" :key="item.property+'_left_center'+index" :class="{'item': item.children.filter(item => item.show).length}">
                    <div v-if="item.show" class="title">
                      <el-checkbox v-model="item.checked" :disabled="search!='' || item.disabled" @change="handleCheckAll($event, item)"><span :id="index" style="margin-left:3px">{{ item.label }}</span></el-checkbox>
                    </div>
                    <div class="box">
                      <div v-for="(sonItem,index) in item.children" v-if="sonItem.show" :key="sonItem.property+'_center'+index" class="box-item">
                        <!--   -->
                        <el-checkbox v-model="sonItem.checked" :disabled="sonItem.disabled" @change="handleChecked($event, item,sonItem)"><span style="margin-left:3px">{{ sonItem.label }}</span></el-checkbox>

                      </div>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
              <div v-else class="tips">
                暂无相关数据
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <!-- :sm="7" :md="7" :lg="7" -->
      <el-col :span="7" style="padding-left: 4px">
        <el-card class="right-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="headerTitle">已选 <span class="nums">{{ selectedData.length }}</span> 列</span>
            <el-button style="float: right; padding: 4px 0" type="text" @click="handleEmpty">清空</el-button>
          </div>
          <div class="card-box">
            <el-scrollbar ref="scroll" wrap-class="scrollbar-wrapper">
              <div v-for="(sonItem,index) in selectedData" v-if="sonItem.checked && sonItem.disabled" :key="sonItem.property+'_right'+index" class="item" :class="sonItem.disabled ? 'disabled' : ''">
                <svg-icon icon-class="draggableIcon1" style="font-size:14px" />
                <span>{{ sonItem.label }}</span>
                <!-- <i class="el-icon-circle-close delete-icon"></i> -->
              </div>
              <draggable :list="selectedData" class="dragArea" :options="{scroll: true}" animation="200">
                <div v-for="(sonItem,index) in selectedData" v-if="sonItem.checked && !sonItem.disabled" :key="sonItem.property+'_right'+index" class="item draggableItem" :class="sonItem.disabled ? 'disabled' : ''">
                  <svg-icon icon-class="draggableIcon1" class="draggableIcon" style="font-size:14px;cursor: move;" />
                  <span>{{ sonItem.label }}</span>
                  <i @click="handleDelete(sonItem,index)">
                    <svg-icon icon-class="clean" style="font-size:14px;cursor: pointer;" />
                  </i>
                </div>
              </draggable>
            </el-scrollbar>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div slot="footer">
      <div style="float: left;line-height: 30px;">
        <el-checkbox v-model="columnForm.isDefault" label="设为默认" />
        <span style="color: #999;font-size: 14px">（设为默认后，下次进入菜单，该报表列默认展示当前配置的指标内容）</span>
      </div>
      <el-button type="primary" plain @click="dialogTableVisible = false">取 消</el-button>
      <el-button v-if="type == 'edit' && columnForm.filterListLength < 5" type="primary" plain @click="handleSave('saveAs')">另存为</el-button>
      <el-button type="primary" :loading="dialogLoading" @click="handleSave">{{ type == 'edit' ? '更新模板' : '确 定' }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import draggable from 'vuedraggable'
import { add_header, edit_header } from '@Bdc~/api/ajax_model'

export default {
  components: { draggable },
  props: {
    // 原始数据
    sourceData: {
      type: Array,
      default: () => []
    },

    // 模块 item
    sourceItem: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      type: 'add', // 'add'新建 'edit'编辑
      columnForm: {
        name: '',
        isDefault: false
      },
      dialogTableVisible: false,
      search: '',
      num: 0, // 已选条数
      dialogLoading: false,
      sourceDataCopy: [],

      current: 0,
      selectedData: [] // 已选
    }
  },

  computed: {
    // 待选过滤
    resultData() {
      const search = this.search.toLowerCase().replace(new RegExp('\\s+', 'g'), '')
      const list = this.sourceData
      if (search) {
        list.forEach(v => {
          v.show = false
          if (v.children && v.children.length > 0) {
            v.children.forEach(item => {
              item.show = false
            })
          }
        })
        list.forEach(v => {
          if (v.children && v.children.length > 0) {
            var nums = 0
            v.children.forEach(item => {
              if (String(item['label']).toLowerCase().indexOf(search) > -1) {
                item.show = true
                nums++
              }
            })
            if (nums > 0) {
              v.show = true
            }
          }
        })
        return list
      }
      list.forEach(v => {
        v.show = true
        if (v.children && v.children.length > 0) {
          v.children.forEach(item => {
            item.show = true
          })
        }
      })
      return list
    }
  },

  created() {
    document.body.ondrop = function(event) {
      event.preventDefault()
      event.stopPropagation()
    }
  },

  methods: {
    // init
    init(data, type, filterListLength) {
      this.current = 0
      // filterListLength是已有筛选的长度 如果>=5 编辑时就不能另存为了
      this.type = type
      this.dialogTableVisible = true
      this.search = ''
      this.columnForm = this.$options.data().columnForm
      this.dialogLoading = false

      if (type == 'edit') {
        this.selectedData = data.filter
        this.columnForm.name = data.name
        this.columnForm.isDefault = !!data.isDefault
        this.columnForm.id = data.id
        this.columnForm.filterListLength = filterListLength
      } else {
        this.selectedData = data
      }
      console.log(this.selectedData)
      console.log(this.resultData)

      this.sourceDataCopy = JSON.parse(JSON.stringify(this.sourceData))
    },

    // 全选
    handleCheckAll(e, obj) {
      if (e) {
        obj.children.forEach(item => {
          item.checked = true
        })
      } else {
        obj.children.forEach(item => {
          if (item.disabled == false) {
            item.checked = false
          }
        })
      }

      if (e) {
        obj.children.forEach(item => {
          var i = false
          this.selectedData.forEach((items, index) => {
            if (items.property == item.property) {
              i = true
            }
          })
          if (!i) {
            this.selectedData.push(item)
          }
        })
      } else {
        obj.children.forEach(item => {
          this.selectedData.forEach((items, index) => {
            if (items.property == item.property && items.disabled == false) {
              this.selectedData.splice(index, 1)
            }
          })
        })
      }

      this.$nextTick(() => {
        this.$refs['scroll'].wrap.scrollTop = 20000
      })
    },

    // 单选
    handleChecked(e, obj, item) {
      let nums = 0
      obj.children.forEach(item => {
        if (item.checked) {
          nums++
        }
      })

      if (nums == obj.children.length) {
        obj.checked = true
      } else {
        obj.checked = false
      }

      if (e) {
        var i = false
        this.selectedData.forEach((items, index) => {
          if (items.property == item.property) {
            i = true
          }
        })
        if (!i) {
          this.selectedData.push(item)
        }
      } else {
        this.selectedData.forEach((items, index) => {
          if (items.property == item.property) {
            this.selectedData.splice(index, 1)
          }
        })
      }

      this.$nextTick(() => {
        this.$refs['scroll'].wrap.scrollTop = 20000
      })
    },

    // 保存
    handleSave(saveAs) {
      // saveAs 另存为
      this.$refs.nameFormRef.validate(valid => {
        if (valid) {
          this.dialogLoading = true
          const param = JSON.parse(JSON.stringify(this.columnForm))
          param.isDefault = Number(param.isDefault)
          param.headerProperty = this.selectedData.map(item => item.property).join(',')
          param.menuId = this.$store.getters.currentRoute.meta.id
          console.log(this.columnForm)
          if (saveAs == 'saveAs') {
            add_header(param, { 'header_view_code': this.sourceItem.code }).then(res => {
              if (res.code == 1) {
                this.$message.success('另存为成功')
                // 这里新建之后 表格要应用这个新建的自定义列 新建成功后台会返回id 拿这个id去请求表格接口
                this.$emit('handleSave', res.data, this.type)
                this.dialogTableVisible = false
              }
            })
          } else {
            if (this.type == 'add') {
              console.log(12)
              add_header(param, { 'header_view_code': this.sourceItem.code }).then(res => {
                if (res.code == 1) {
                  this.$message.success('创建成功，可在报表筛选列中查看')
                  // 这里新建之后 表格要应用这个新建的自定义列 新建成功后台会返回id 拿这个id去请求表格接口
                  this.$emit('handleSave', res.data, this.type)
                  this.dialogTableVisible = false
                }
              })
            } else {
              edit_header(param, { 'header_view_code': this.sourceItem.code }).then(res => {
                if (res.code == 1) {
                  this.$message.success('更新成功')
                  this.$emit('handleSave', this.columnForm.id, this.type)
                  this.dialogTableVisible = false
                }
              })
            }
          }
        }
      })
    },

    // 锚点
    tabclick(index) {
      this.current = index
      const anchorElement = document.getElementById(index)
      if (anchorElement) {
        anchorElement.scrollIntoView()
      }
    },

    // 清空
    handleEmpty() {
      var datas = []
      this.selectedData.forEach((item, index) => {
        if (item.disabled == true) {
          datas.push(item)
        }
      })
      this.selectedData = datas

      this.resultData.forEach(arr => {
        if (arr.children && arr.children.length > 0) {
          var nums = arr.children.length
          arr.children.forEach(item => {
            if (item.disabled == false) {
              item.checked = false
              nums--
            }
          })
          if (nums != arr.children.length) {
            arr.checked = false
          }
        }
      })
    },

    // 删除
    handleDelete(item, index) {
      console.log('aaaaaaaaaaa')
      if (item.disabled == false) {
        this.resultData.forEach(arr => {
          let nums = arr.children.length
          arr.children.forEach(items => {
            if (items.property == item.property) {
              items.checked = false
              nums--
            }
          })
          if (nums != arr.children.length) {
            arr.checked = false
          }
        })

        this.selectedData.splice(index, 1)
      }
    }

  }

}
</script>

<style lang="scss" scoped>

.dialog-box {
  ::v-deep .el-dialog{
    border-radius: 4px;
  }
  ::v-deep .el-dialog__header {
    padding: 21px 24px;
  }
  ::v-deep .el-dialog__body {
    padding: 0px 24px 10px;
  }
  ::v-deep .el-card__header {
    padding: 5px 12px;
    line-height: 28px;
    background: #f7f7f7;

    .el-input__inner {
      border-radius: 4px;
    }

    .headerTitle {
      font-size: 14px;
      color: #999999;

      .nums {
        font-weight: bold;
        color: #333;
      }
    }
  }
  ::v-deep .el-card__body {
    padding: 0px 12px;
  }
  .lef-list {
    height: 380px;
    padding: 10px 10px 0 0;
    border-right: 1px solid #e1e3e7;
    .item {
      cursor: pointer;
      height: 40px;
      line-height: 40px;
      background: #fff;
      color: #666;
      font-size: 14px;
      position: relative;
    }
  }
  .right-list {
    padding: 6px 10px 0px 0px;
    height: 380px;
    display: flex;
    flex-direction: column;
    .item {
      margin-bottom: 20px;
      .title {
        height: 30px;
        line-height: 30px;
        padding-bottom: 5px;
        border-bottom: 1px solid #e1e3e7;
        color: #132344;
        font-size: 14px;
        font-weight: bolder;
        margin-bottom: 4px;
      }
      .box {
        display: flex;
        flex-wrap: wrap;
      }
    }
    .box-item {
      margin: 10px 1% 5px 1%;
      min-width: 31%;
    }
  }

  ::v-deep .scrollbar-wrapper {
    overflow-x: hidden !important;
  }

  .el-scrollbar__bar.is-vertical {
    right: 0px;
  }

  .el-scrollbar {
    height: 100%;
  }

  .tips {
    height: 300px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #b5b5b5;
  }

  .active {
    background: #f0f6ff;
    color: #3A89FF !important;
  }

  .right-card {
    .card-box {
      margin: 10px 0;
      height: 330px;
    }
    .item {
      height: 32px;
      line-height: 32px;
      margin-bottom: 8px;
      padding: 0 10px;
      background: #e2eeff;
      border: 1px solid #e2eeff;
      border-radius: 3px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4b5276;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;

      span {
        flex: 1;
        margin: 0 5px;
        cursor: move;
      }
      i {
        font-size: 16px;
        color: #aeb3c4;
      }
      .lie-icon {
        cursor: move;
      }
      .delete-icon {
        color: #9ebadf;
        cursor: pointer;
      }
    }
    .draggableItem:hover {
      opacity: 0.9;
      .draggableIcon {
        color: #1d71e8;
      }
    }
    .disabled {
      color: #c0c4cc;
      cursor: not-allowed;
      background-image: none;
      background-color: #fff;
      border-color: #ebeef5;
      .delete-icon {
        cursor: not-allowed !important;
      }
    }
  }
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
::v-deep .el-input__prefix{
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding-left: 3px;
}
.el-checkbox{
  ::v-deep .el-checkbox__inner{
    border-radius: 4px;
  }
  ::v-deep .el-checkbox__label{
    color: #333
  }
}

</style>
